import { render } from "./GroupedLabelItem.vue?vue&type=template&id=1605650c&scoped=true"
import script from "./GroupedLabelItem.vue?vue&type=script&lang=js"
export * from "./GroupedLabelItem.vue?vue&type=script&lang=js"

import "./GroupedLabelItem.vue?vue&type=style&index=0&id=1605650c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1605650c"]])

export default __exports__